<app-loader [isLoading]="isLoading"></app-loader>


<div class="the_container">
    <div class="d-flex justify-content-between mob-view">
        <span class="details-text">Bank Transaction Settlement Report</span>
        <div class="filter-div">
            <mat-form-field class="select-mat-form-field custom-select-form select-width">
                <mat-select class="custom-mat-select custom-select" id="region" placeholder=""
                    [formControl]="regionWise">
                    @for(item of dropArr; track item){
                    <mat-option [value]="item.id">
                        {{item.value}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <button class="buttonContent dp-primary-btn d-flex" (click)="onClickFilter()">
                filter <img src="../../../../assets/filter.svg" style="width: 15px; height: 15px;">
            </button>
        </div>

    </div>
    <div class="dashboard-header">

        <div class="row">
            <div class="col-md-12">
                <div class="bredcrumb">
                    <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; let last = last">
                        <span (click)="onClickBreadcrumb(breadcrumb)" [ngClass]="
                    !last ? 'brancd-prime me-2 cursor-pointer' : 'text-disable me-2'
                  ">{{ breadcrumb }}</span>
                        <img *ngIf="!last" src="../../assets/images/chevron.svg" class="me-2" />
                    </ng-container>
                </div>
            </div>
        </div>

    </div>

    <hr class="horiz-line">
    <div class="data-stats">
        <div class="data-container">
            <span class="data-text">CBI</span>
            <span class="data-number">{{stateData.CBI || '-'}}</span>
        </div>
        <div class="data-container">
            <span class="data-text">SBI</span>
            <span class="data-number">{{stateData.SBI || '-'}}</span>
        </div>

        <div class="data-container">
            <span class="data-text">PNB</span>
            <span class="data-number">{{stateData.PNB || '-'}}</span>
        </div>
        <div class="data-container">
            <span class="data-text">UCO</span>
            <span class="data-number">{{stateData.UCO || '-'}}</span>
        </div>
        <div class="data-container">
            <span class="data-text">BOI</span>
            <span class="data-number">{{stateData['Bank Of INDIA'] || '-'}}</span>
        </div>
        <div class="data-container">
            <span class="data-text">Indian Allahabad Bank</span>
            <span class="data-number">{{stateData['INDIAN ALLAHABAD BANK'] || '-'}}</span>
        </div>
    </div>
    <hr class="horiz-line">



    <div class="table-container">
        @if(selectedState === ''){
        <table class="table">
            <thead class="table-head">
                <tr>

                    <th>
                        <span>State</span>
                    </th>
                    <th>
                        <span>Unsettled Count</span>
                    </th>

                </tr>
            </thead>
            <tbody class="table-body">
                @for(row of stateData.tableData; track row){
                <tr>
                    <td data-label="State" class="hover-item" (click)="onClickState(row.state)">
                        {{row.state}}
                    </td>
                    <td data-label="Unsettled Count">
                        {{row.unsettled}}
                    </td>
                </tr>
                }

            </tbody>
        </table>
        }@else if(selectedState && selectedDistrict == ''){
        <table class="table">

            <thead class="table-head">
                <tr>

                    <th>
                        <span>State</span>
                    </th>
                    <th>
                        <span>District</span>
                    </th>
                    <th>
                        <span>Unsettled Count</span>
                    </th>
                </tr>
            </thead>

            <tbody class="table-body">
                @for(row of stateData.tableData; track row){
                <tr>
                    <td data-label="State">
                        {{row.state}}
                    </td>
                    <td data-label="District" class="hover-item" (click)="onClickDistrict(row.district)">
                        {{row.district}}
                    </td>
                    <td data-label="Unsettled Count" class="hover-item" (click)="getBankStatement(row)">
                        {{row.unsettled}}
                    </td>

                </tr>
                }
            </tbody>
        </table>
        }@else{
        <table class="table">
            <thead class="table-head">
                <tr>

                    <th>
                        <span>State</span>
                    </th>
                    <th>
                        <span>District</span>
                    </th>
                    <th>
                        <span>Pincode</span>
                    </th>
                    <th>
                        <span>Unsettled Count</span>
                    </th>

                </tr>
            </thead>

            <tbody class="table-body">
                @for(row of stateData.tableData; track row){
                <tr>
                    <td data-label="State">
                        {{row.state}}
                    </td>
                    <td data-label="District">
                        {{row.district}}
                    </td>
                    <td data-label="Pincode">
                        {{row.pincode}}
                    </td>
                    <td data-label="Unsettled Count" class="hover-item" (click)="getBankStatement(row)">
                        {{row.unsettled}}
                    </td>

                </tr>
                }
            </tbody>
        </table>
        }
    </div>
</div>

